import React, { useState } from "react";
import "./GroupSendMessageModal.css";
import UserChip from "../../../../components/user-chip/UserChip";

type Member = {
  id: number;
  first_name: string;
};

type Props = {
  groupName: string;
  selectedMembers: Member[];
  onClose: () => void;
  onSend: (message: string) => void;
  loading: boolean;
};

const GroupSendMessageModal: React.FC<Props> = ({
  groupName,
  selectedMembers,
  onClose,
  onSend,
  loading = false,
}) => {
  const [message, setMessage] = useState("");

  console.log("selectedMembers", selectedMembers);

  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
    }
  };

  return (
    <div className="groupMessage-overlay">
      <div className="groupMessage-modal">
        <h3>Send Message</h3>

        <div className="groupMessage-modal-content">
          <div className="groupMessage-form-group">
            <label>Group Name</label>
            <p className="groupMessage-group-name">{groupName}</p>
          </div>

          <div className="groupMessage-form-group">
            <label>Selected ({selectedMembers.length}):</label>
            <div className="groupMessage-member-chips">
              {selectedMembers.map((m) => (
                <UserChip key={m.id} id={m.id} userName={m.first_name} />
              ))}
            </div>
          </div>

          <div className="groupMessage-form-group">
            <label>
              Message <span className="groupMessage-required">*</span>
            </label>
            <textarea
              placeholder="Enter Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </div>

        <div className="groupMessage-actions">
          <button
            className="groupMessage-btn groupMessage-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="groupMessage-btn groupMessage-submit"
            onClick={handleSend}
            disabled={!message.trim() || loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupSendMessageModal;
